import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { DateTimeInput } from "@common/dateTimeInput";
import { ElementAttachmentsUpload } from "./elementAttachmentsUpload";
import { ElementAttachments } from "./elementAttachments";
import { ExpenseTypeSelect } from "./expenseTypeSelect";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, project, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <div className={classNames(styles.group, styles.wideCell)}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.name")}
          </h2>
          <TextInput
            placeholder={t("projectBudgetSynthesis.expenses.name")}
            value={formData.name}
            input={(name) => edit({ ...formData, name })}
            autoFocus
          />
        </div>
        <div className={classNames(styles.group)}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.orderNumber")}
          </h2>
          <TextInput
            placeholder={t("projectBudgetSynthesis.expenses.orderNumber")}
            value={formData.orderNumber}
            input={(orderNumber) => edit({ ...formData, orderNumber })}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.expenseType")}
          </h2>
          <ExpenseTypeSelect formData={formData} edit={edit} />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.creation.unitAmount")}
          </h2>
          <TextInput
            placeholder={t(
              "projectBudgetSynthesis.expenses.creation.unitAmount",
            )}
            value={formData.unitAmount}
            input={(unitAmount) => edit({ ...formData, unitAmount })}
          />
        </div>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.creation.quantity")}
          </h2>
          <TextInput
            placeholder={t("projectBudgetSynthesis.expenses.creation.quantity")}
            value={String(formData.quantity)}
            input={(quantity) =>
              edit({ ...formData, quantity: Number(quantity) })
            }
          />
        </div>
      </div>
      <div className={styles.row}>
        <h2 className={styles.label}>
          {t("projectBudgetSynthesis.expenses.totalAmount")} ={" "}
          {Number(formData.unitAmount) * formData.quantity} €
        </h2>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.plannedDate")}
          </h2>
          <DateTimeInput
            placeholder={t("projectBudgetSynthesis.expenses.plannedDate")}
            dateTime={formData.plannedDate}
            projectTimezone={project.timeZone}
            calendarPosition="TOP"
            input={(plannedDate) => edit({ ...formData, plannedDate })}
            clear={() => edit({ ...formData, plannedDate: "" })}
          />
        </div>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.actualDate")}
          </h2>
          <DateTimeInput
            placeholder={t("projectBudgetSynthesis.expenses.actualDate")}
            dateTime={formData.actualDate}
            projectTimezone={project.timeZone}
            calendarPosition="TOP"
            input={(actualDate) => edit({ ...formData, actualDate })}
            clear={() => edit({ ...formData, actualDate: "" })}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("projectBudgetSynthesis.expenses.attachments")}
          </h2>
          <div className={styles.attachments}>
            <ElementAttachmentsUpload
              project={project}
              element={formData}
              elementType="EXPENSE"
              selectDocuments={(documents) =>
                edit({ ...formData, attachments: documents })
              }
            />
            <ElementAttachments
              attachments={formData.attachments}
              removeDocument={(document) =>
                edit({
                  ...formData,
                  attachments: formData.attachments.filter(
                    ({ uuid }) => uuid !== document.uuid,
                  ),
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { Form };
